const TYPES = {
  UNSET_AVATAR: 'UNSET_AVATAR',
  UPLOAD_AVATAR: 'UPLOAD_AVATAR',
  CHANGE_INFO_USER: 'CHANGE_INFO_USER',
};

export const VOTE_TYPES = {
  LIKE: 'like',
  DISLIKE: 'dislike',
  WITHDRAW: 'withdraw',
};

export default TYPES;
